export default __webpack_public_path__ + "static/media/icon_plaint.a752db71.svg";